import React, { useState, useEffect } from "react";
import Loading from "@/app/core/layouts/main/components/Loading";
import Storage from "@/app/core/util/Storage";
import home from "@/assets/img/home.png";
import cotacao from "@/assets/img/cotacao.png";
import rastreamento from "@/assets/img/rastreamento.png";
import documentos from "@/assets/img/documentos.png";
import pedidos from "@/assets/img/pedidos.png";
import cobranca from "@/assets/img/cobranca.png";
import ajuda from "@/assets/img/ajuda.png";
import suporte from "@/assets/img/suporte.png";
import termos from "@/assets/img/termos.png";
import { ToastContainer, toast } from "react-toastify";
import { Tabs, Tab, Panel } from "@bumaga/tabs";
import HomeComponent from "../HomeComponent";
import CreditCardModal from "@/app/core/layouts/main-components/charge/CreditCardModal";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import AllTerms from "@/app/modules/terms/main";
import UserProfile from "@/app/modules/profile/main";
import MyDeliveries from "@/app/modules/deliveries/main";
import TrackingComponent from "@/app/modules/tracking/main";
import ChargingComponent from "@/app/modules/charging/main";
import Quotation from "@/app/modules/quotation/main";
import CheckMobile from "@/app/core/util/Screen";
import DocumentsComponent from "@/app/modules/documents/main";
import CompanyComponent from "@/app/modules/company/main";
import AddressBookcomponent from "@/app/modules/addressBook/main";

export default function MainDashboard(props) {
  const userData = Storage.getUserData();
  const [loading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const isMobile = CheckMobile();
  useEffect(() => { }, []);

  return (
    <>
      <Loading loading={loading} />
      <div className={Storage.getTheme()}>
        <div className="ml-3 mr-3 mt-3 mb-3">
          <Tabs>
            <div className="row">
              {isMobile != true ? (
                <div className="col-md-2 border-right">
                  <div class="block block-rounded block-link-shadow text-center">
                    <div class="block-content block-content-full bg-body-light">
                      <img class="img-avatar" src="assets/media/avatars/avatar7.jpg" />
                    </div>
                    <div class="block-content block-content-full">
                      <p class="font-size-sm font-italic text-muted mb-0">
                        Olá
                      </p>
                      <p class="font-w600 mb-0">{userData && `${userData.firstName} ${userData.lastName}`}</p>
                    </div>
                  </div>
                  <h2 className="content-heading">
                    <i className="fa fa-angle-right text-muted mr-1"></i>{" "} Geral
                  </h2>
                  <div className="py-1">
                    <Tab>
                      <button className="btn btn-hero btn-dual ml-1 mr-1">
                        <img src={home} className="img-avatar img-avatar32 mr-2" />
                        {/* <i className="si si-home mr-2" /> */}
                        {Translate(Message.Menu.Home)}
                      </button>
                    </Tab>
                  </div>
                  <div className="py-1">
                    <Tab>
                      <button className="btn btn-hero btn-dual ml-1 mr-1">
                        <img src={cotacao} className="img-avatar img-avatar32 mr-2" />
                        {/* <i className="si si-notebook mr-2" /> */}
                        {Translate(Message.Menu.Quotation)}
                      </button>
                    </Tab>
                  </div>
                  <div className="py-1">
                    <Tab>
                      <button className="btn btn-hero btn-dual ml-1 mr-1">
                        <img src={rastreamento} className="img-avatar img-avatar32 mr-2" />
                        {/* <i className="si si-pin mr-2" /> */}
                        {Translate(Message.Menu.Tracking)}
                      </button>
                    </Tab>
                  </div>
                  <div className="py-1">
                    <Tab>
                      <button className="btn btn-hero btn-dual ml-1 mr-1">
                        <img src={documentos} className="img-avatar img-avatar32 mr-2" />
                        {/* <i className="far fa-file mr-2" /> */}
                        {Translate(Message.Menu.Documents)}
                      </button>
                    </Tab>
                  </div>

                  <div className="py-1">
                    <Tab>
                      <button className="btn btn-hero btn-dual ml-1 mr-1">
                        <img src={pedidos} className="img-avatar img-avatar32 mr-2" />
                        {/* <i className="si si-globe-alt mr-2" /> */}
                        {Translate(Message.Menu.MyDeliveries)}
                      </button>
                    </Tab>
                  </div>

                  <div className="py-1">
                    <Tab>
                      <button className="btn btn-hero btn-dual ml-1 mr-1">
                        <img src={cobranca} className="img-avatar img-avatar32 mr-2" />
                        {/* <i className="si si-wallet mr-2" /> */}
                        {Translate(Message.Menu.Billing)}
                      </button>
                    </Tab>
                  </div>

                  <div className="py-1">
                    <Tab>
                      <button className="btn btn-hero btn-dual ml-1 mr-1">
                        {/* <i className="si si-user mr-2" /> */}
                        <img src={termos} className="img-avatar img-avatar32 mr-2" />
                        {Translate(Message.Menu.AddressList)}
                      </button>
                    </Tab>
                  </div>
                  <div className="py-1">
                    <Tab>
                      <button className="btn btn-hero btn-dual ml-1 mr-1">
                        {/* <i className="si si-user mr-2" /> */}
                        <img src={termos} className="img-avatar img-avatar32 mr-2" />
                        {Translate(Message.Menu.Profile)}
                      </button>
                    </Tab>
                  </div>
                  {userData && userData.companyId != undefined && userData.companyId != "" ?
                    <div className="py-1">
                      <Tab>
                        <button className="btn btn-hero btn-dual ml-1 mr-1">
                          {/* <i className="far fa-building mr-2" /> */}
                          <img src={termos} className="img-avatar img-avatar32 mr-2" />
                          {Translate(Message.Menu.Company)}
                        </button>
                      </Tab>
                    </div>
                    : ""}
                  <h2 className="content-heading">
                    <i className="fa fa-angle-right text-muted mr-1"></i>{" "} Suporte e Ajuda
                  </h2>
                  <div className="py-1">
                    <Tab>
                      <button className="btn btn-hero btn-dual ml-1 mr-1">
                        <img src={ajuda} className="img-avatar img-avatar32 mr-2" />
                        {/* <i className="si si-question mr-2" /> */}
                        {Translate(Message.Menu.Help)}
                      </button>
                    </Tab>
                  </div>
                  <div className="py-1">
                    <Tab>
                      <button className="btn btn-hero btn-dual ml-1 mr-1">
                        {/* <i className="si si-support mr-2" /> */}

                        <img src={suporte} className="img-avatar img-avatar32 mr-2" />
                        {Translate(Message.Menu.Suport)}
                      </button>
                    </Tab>
                  </div>
                  <div className="py-1">
                    <Tab>
                      <button className="btn btn-hero btn-dual ml-1 mr-1">
                        {/* <i className="si si-list mr-2" /> */}
                        <img src={termos} className="img-avatar img-avatar32 mr-2" />
                        {Translate(Message.Menu.Terms)}
                      </button>
                    </Tab>
                  </div>
                </div>
              ) : ""}
              <div className={`col-md-${isMobile == false ? "10" : "12"}`}>
                <Panel>
                  <HomeComponent />
                </Panel>
                <Panel>
                  <Quotation props={props} />
                </Panel>
                <Panel>
                  <TrackingComponent />
                </Panel>
                <Panel>
                  <DocumentsComponent />
                </Panel>
                <Panel>
                  {/* Pedidos */}
                  <MyDeliveries />
                </Panel>
                <Panel>
                  <ChargingComponent />
                </Panel>
                <Panel>
                  <AddressBookcomponent />
                </Panel>
                <Panel>
                  <UserProfile />
                </Panel>
                <Panel>
                  <CompanyComponent />
                </Panel>
                <Panel>
                  <HomeComponent />
                </Panel>
                <Panel>
                  <AllTerms />
                </Panel>
                <Panel>
                  <AllTerms />
                </Panel>
              </div>
            </div>
          </Tabs>
        </div>
      </div>
      <CreditCardModal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
      <ToastContainer className="toastr" />
    </>
  );
}
